import { isDev } from "./commonMobile";

const devPhaserGames = new Map<string, string>([
	["m10", "headtail_ge_dev"],
	["m22c", "baccarat_ge_dev"],
	["m40", "xocdia_ge_dev"],
	["m41", "domino_ge_dev"]
]);

const livePhaserGames = new Map<string, string>([
	["m40", "xocdia_ge"]
]);

const hasPhaserGame = (pcode: string) =>
	isDev()
	? devPhaserGames.has(pcode) // false
	: livePhaserGames.has(pcode);

const getPhaserGameDir = (pcode: string): string | undefined =>
	isDev()
	? `idnlive_phaser3/${devPhaserGames.get(pcode)}` || undefined
	: livePhaserGames.get(pcode) || undefined;

/**
 * Automatically redirects to Phaser Game, if any.
 * Does nothing if it doesn't exist.
 */
function redirectToPhaserGame(pcode: string, operatorId?: string) {
	console.log("rTPG opId:", operatorId)

	if (!hasPhaserGame(pcode) || operatorId === "850694273")
		return;

	const { origin } = window.location;
	window.location.assign(`${origin}/${getPhaserGameDir(pcode)}/`);
}

export {
	devPhaserGames,
	livePhaserGames,

	hasPhaserGame,
	getPhaserGameDir,

	redirectToPhaserGame
};